import React, { useMemo } from "react";
import { TextBox } from "../text-box";
import { Radio } from "../../ui/radio";
import { Input } from "../../ui/input";
import { Checkbox } from "../../ui/checkbox";
import { Select } from "../../ui/select";
import { useUI } from "../../context";

export const Step3 = (props) => {
  const {
    page_settings: { step2, step3 },
  } = useUI();

  const isObjective = useMemo(() => {
    return props.watch(step2.fieldObjective) === step2.valueCheckbox1;
  }, [props]);

  const isCompany = useMemo(() => {
    return props.watch(step3.fieldCheckboxes) === step3.valueCheckbox2;
  }, [props]);

  const isDisabled = useMemo(() => {
    return props.watch("no-company-number");
  }, [props]);

  const isConditionalField = useMemo(() => {
    return props.watch(step3.fieldDesiredDestination) === "other";
  }, [props]);

  return (
    <>
      <TextBox title="Remplissez le formulaire ci-dessous" />
      {isObjective && (
        <div className="flex flex-col gap-4 lg:flex-row lg:gap-6 max-lg:pb-10 max-lg:border-b max-lg:border-gray-modern-300">
          <div className="flex-1">
            <Radio
              isSmall={true}
              icon="user"
              name={step3.fieldCheckboxes}
              label={step3.labelCheckbox1}
              value={step3.valueCheckbox1}
              register={props.register}
              defaultChecked
              isChecked={props.watch(step3.fieldCheckboxes) === step3.valueCheckbox1}
            />
          </div>
          <div className="flex-1">
            <Radio
              isSmall={true}
              name={step3.fieldCheckboxes}
              label={step3.labelCheckbox2}
              value={step3.valueCheckbox2}
              register={props.register}
              isChecked={props.watch(step3.fieldCheckboxes) === step3.valueCheckbox2}
            />
          </div>
        </div>
      )}
      <div className="flex flex-col gap-4 max-lg:pt-4">
        {isCompany && (
          <Input
            name={step3.fieldCompanyName}
            placeholder={step3.labelFieldCompanyName}
            register={props.register}
            isError={!!props.errors[step3.fieldCompanyName]}
          />
        )}
        <Input
          name={step3.fieldActivity}
          placeholder={step3.labelFieldActivity}
          register={props.register}
          isError={!!props.errors[step3.fieldActivity]}
        />
        {isCompany && (
          <Input
            name={step3.fieldSocial}
            placeholder={step3.labelFieldSocial}
            register={props.register}
            isError={!!props.errors[step3.fieldSocial]}
          />
        )}
        {!isObjective && (
          <Input
            name={step3.fieldNameAsb}
            placeholder={step3.labelFieldNameAsb}
            register={props.register}
            isError={!!props.errors[step3.fieldNameAsb]}
          />
        )}
        <div className="flex flex-col lg:flex-row gap-4">
          <div className="flex flex-col w-full gap-2">
            <Input
              type="number"
              name={step3.fieldCompanyNumber}
              placeholder={step3.labelFeildCompanyNumber}
              disabled={isDisabled}
              register={props.register}
              isError={!!props.errors[step3.fieldCompanyNumber]}
              error={props.errors[step3.fieldCompanyNumber]}
            />

            {props.errors[step3.fieldCompanyNumber] &&
              props.errors[step3.fieldCompanyNumber].message && (
                <span className="text-text-sm text-error-600">{step3.errorTextCompanyNumber}</span>
              )}
          </div>
          {isCompany && (
            <Input
              name={step3.fieldYourFunction}
              placeholder={step3.labelFieldYourFunction}
              register={props.register}
              isError={!!props.errors[step3.fieldYourFunction]}
            />
          )}
        </div>
        <Checkbox register={props.register} id="no-company-number" name="no-company-number">
          {step3.checkboxLabelCompanyNumber}
        </Checkbox>
        {isObjective ? (
          <>
            <Select name={step3.fieldDesiredDestination} register={props.register}>
              {step3.variantsFeildDesiredDestination.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.title}
                </option>
              ))}
            </Select>
            {isConditionalField && (
              <Input
                name={step3.fieldConditional}
                placeholder={step3.labelFieldConditional}
                register={props.register}
                isError={!!props.errors[step3.fieldConditional]}
              />
            )}
          </>
        ) : (
          <Input
            name={step3.fieldYourFunction}
            placeholder={step3.labelFieldYourFunction}
            register={props.register}
            isError={!!props.errors[step3.fieldYourFunction]}
          />
        )}
      </div>
    </>
  );
};
